module.exports = __webpack_public_path__ + "static/img/3s-info-b1.c468cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-info-b1.png
// module id = uRk5
// module chunks = 0